.tooltip {
  :global(.rt-TooltipText) {
    width: 100%;
  }

  :global(.rt-TooltipArrow) {
    fill: var(--tooltip-background-color) !important;
  }
}

.selectable {
  :global(.rt-TooltipText) {
    user-select: auto;
  }
}
